import styles from "@/components/OnwardLinks/OnwardLinks.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { OnwardLink } from "@/components/OnwardLinks/OnwardLinksUI.tsx";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import { sendEvent } from "@JohnLewisPartnership/experiments-utils";
import classNames from "classnames/bind";
import { ONWARD_LINK_CARD_CLICKED_EVENT } from "@/components/OnwardLinks/OnwardLinks.tsx";

type Props = {
  onwardLinks: OnwardLink[];
};

export const OnwardLinksImageCards = ({ onwardLinks }: Props) => {
  const cx = classNames.bind(styles);

  const handleOnwardLinkClick = () => sendEvent(ONWARD_LINK_CARD_CLICKED_EVENT);

  return (
    <ul
      className={cx(
        styles.onwardLinks,
        onwardLinks.length === 4 ? styles.justifyEvenly : styles.justifyCenter,
      )}
    >
      {onwardLinks.map((link: OnwardLink, i) => {
        return (
          <li
            className={cx(
              "onwardLink",
              link.title === "" ? "loading" : "content",
            )}
            key={i}
          >
            <UnderlinedButton
              className={styles.externalButton}
              tag="a"
              rel="noreferrer"
              href={link.url}
              onClick={handleOnwardLinkClick}
            >
              {link.imageUrl && (
                <img
                  src={formatAmplienceImageURL(link.imageUrl)}
                  alt={link.title}
                />
              )}
              <span>{link.title}</span>
            </UnderlinedButton>
          </li>
        );
      })}
    </ul>
  );
};
